import { render } from "./basePage.vue?vue&type=template&id=c4019b28&scoped=true"
import script from "./basePage.vue?vue&type=script&lang=js"
export * from "./basePage.vue?vue&type=script&lang=js"

import "./basePage.vue?vue&type=style&index=0&id=c4019b28&scoped=true&lang=css"

import exportComponent from "C:\\Project\\VuePro\\DTP\\dtp_index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4019b28"]])

export default __exports__